/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Err_Tournament_Table_Count_MismatchInputs */



/**
* | output |
* | --- |
* | "Table count mismatch" |
*
* @param {Err_Tournament_Table_Count_MismatchInputs} inputs
* @param {{ locale?: "en" | "fr" | "es" | "pt" | "it" }} options
* @returns {LocalizedString}
*/
export const err_tournament_table_count_mismatch = /** @type {((inputs?: Err_Tournament_Table_Count_MismatchInputs, options?: { locale?: "en" | "fr" | "es" | "pt" | "it" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Err_Tournament_Table_Count_MismatchInputs, { locale?: "en" | "fr" | "es" | "pt" | "it" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return /** @type {LocalizedString} */ ("Nombre de tables incorrect")
	if (locale === "es") return /** @type {LocalizedString} */ ("Número de mesas incorrecto")
	if (locale === "pt") return /** @type {LocalizedString} */ ("Número de mesas incorreto")
	if (locale === "it") return /** @type {LocalizedString} */ ("Numero di tavoli non corretto")
	return /** @type {LocalizedString} */ ("Table count mismatch")
});